import language from '@/config/language/index';
import { useAppSelector } from '@/state/hooks';
import { selectLanguage } from '@/state/reducers/languageSlice';
import { store } from '@/state/store';

export type UseLanguageReturn = typeof language['en'] & { dir: 'ltr' | 'rtl' } & { locale: string };

const useLanguage = (): UseLanguageReturn => {
    const lang = useAppSelector(selectLanguage);

    return { ...language[lang], dir: lang === 'ar' ? 'rtl' : 'ltr', locale: lang };
};

export default useLanguage;

export const getLanguage = (): UseLanguageReturn => {
    const lang = store.getState().language.language;
    return {
        ...(language[lang] || language['en']),
        dir: lang === 'ar' ? 'rtl' : 'ltr',
        locale: lang
    };
};
